import { RubricAction, RubricActionType } from '../actionTypes/rubric';
import { EvaluationRubric } from '../types';

const EvaluationRubricReducer = (
    state: Array<EvaluationRubric> = [],
    action: RubricAction
) => {
    let updatedState: EvaluationRubric[];
    switch (action.type) {
        case RubricActionType.GET_RUBRICS:
        case RubricActionType.GET_PROJECT_RUBRICS:
            return action.payload;
        case RubricActionType.UPDATE_RUBRIC:
            return state.map((rubric: EvaluationRubric) => {
                const newRubric = action.payload as EvaluationRubric;
                if (rubric._id === newRubric._id) {
                    return newRubric;
                } else {
                    return rubric;
                }
            });
        case RubricActionType.CREATE_RUBRIC:
            return [...state, action.payload];
        case RubricActionType.DELETE_RUBRIC:
            updatedState = state.filter(
                (rubric) => rubric._id !== action.payload?._id ?? []
            );
            return [...updatedState];

        default:
            return state;
    }
};

export default EvaluationRubricReducer;
